import Vue from 'vue';
import i18n from '../../../content/lang/content.i18n';
import { LocaleMessage } from 'vue-i18n';


export default Vue.component('ed-select', { 
  props: ['change', 'options', 'selected', 'label', 'disabled'],
  data: () => {
    return {
      labelDefault: i18n.t('common.select'),
      optionSelected: {
        key: null,
        value: null
      }
    }
  },
  computed: {
    labelSelected(): string | null | LocaleMessage {
      return this.optionSelected.value ? this.optionSelected.value : this.labelDefault;
    },
    isDisabled() {
      return typeof this.disabled !== 'undefined' ? this.disabled : false;
    },
    selectClasses() {
      return {
        'disabled': this.isDisabled
      }
    }
  },
  name: 'ed-select',
  methods: {
    selectOption(key: string) {
      let option = this.options.find((o:any) => String(o.key) === String(key));
      this.optionSelected = option;
      this.$emit('change', option);
    }
  },
  mounted() {
    if(this.selected) {
      let option = this.options.find((o: any) => { return (String(o.key) === String(this.selected)) });
      this.optionSelected = option;
    }
  }
});